// eslint-disable-next-line
import LinkIcon from '!!raw-loader!@img/icons/link.svg';
// eslint-disable-next-line
import PlusIcon from '!!raw-loader!@img/icons/plus.svg';
import InlineEditor from '@UI/editor/InlineEditor';
import type { RootState } from '@generalTypes/rootStateTypes';
import { createNewsitemFromTeaser } from '@newStore/documentApi/documentApiState';
import { openAside } from '@newStore/documentUI/documentUIState';
import type { TeaserNode } from '@newStore/documentUI/documentUITypes';
import { selectAppliedNodeConfig } from '@newStore/documentUI/nodeTypeConfigSelectors';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPlaceHolderLabel } from '../../contentRowHelpers';
import './TeaserRow.scss';

const TeaserRow: React.FC<{ contentNode: TeaserNode }> = ({ contentNode }) => {
  const [creating, setCreating] = useState(false);
  const dispatch = useDispatch();
  const nodeTypeConfig = useSelector((state: RootState) =>
    selectAppliedNodeConfig(state, contentNode.href),
  );

  const canCreateNewsItem = useSelector(
    (state: RootState) =>
      state.document.pendingActions.length === 0 &&
      state.document.viewModel.isValid && // TODO: check validation with a selector
      state.documentUI.mode === 'EDIT',
  );

  const showLinkAndButtons = useSelector(
    (state: RootState) =>
      state.documentUI.currentDocument === contentNode.href && !contentNode.linkedContentLoading,
  );

  const addLink = () => {
    dispatch(openAside({ href: contentNode.href, asideTab: 'metadata' }));
    setTimeout(() => document.getElementById('linkedContent')?.scrollIntoView(), 500);
  };

  const createNewsItem = () => {
    setCreating(true);
    dispatch(createNewsitemFromTeaser({ teaserHref: contentNode.href }));
  };

  if (!contentNode) {
    return null;
  }

  return (
    <>
      {showLinkAndButtons && (
        <div className="teaser-header">
          <div className="teaser-link">
            {contentNode.linkedContent === null && <div>Niet gelinkt</div>}
            {contentNode.linkedContent?.documentKey && (
              <div>
                <a href={`/edit/${contentNode.linkedContent?.documentKey}`}>
                  {contentNode.linkedContent?.title}
                </a>
                {contentNode.linkedContent?.issued ? 
                  <span style={{ color: 'green', marginLeft: '10px' }}>
                    (reeds gepubliceerd)
                  </span>
                 : 
                  <span style={{ color: 'red', marginLeft: '10px' }}>
                    (nog niet gepubliceerd)
                  </span>
                }
              </div>
            )}
            {contentNode.linkedContent?.url && (
              <div>
                <a href={contentNode.linkedContent?.url} target="_blank" rel="noreferrer">
                  {contentNode.linkedContent?.title}
                </a>
              </div>
            )}
          </div>
          {contentNode.linkedContent === null && (
            <div className="teaser-buttons">
              <button
                className="btn btn-teaser"
                onClick={createNewsItem}
                disabled={!canCreateNewsItem || creating}
              >
                {creating ? (
                  <>Laden...</>
                ) : (
                  <>
                    <span dangerouslySetInnerHTML={{ __html: PlusIcon }} />
                    <span className="btn-teaser-label">Nieuwsbericht maken</span>
                  </>
                )}
              </button>
              <button className="btn btn-teaser" onClick={addLink}>
                <span dangerouslySetInnerHTML={{ __html: LinkIcon }} />
                <span className="btn-teaser-label">Linken</span>
              </button>
            </div>
          )}
        </div>
      )}

      <div>
        <h4>
          <InlineEditor
            initial={contentNode.title}
            field="title"
            placeholder={getPlaceHolderLabel(nodeTypeConfig, 'title')}
            skey={contentNode.key}
            href={contentNode.href}
          />
        </h4>
        <div className="teaser-content">
          {'image' in contentNode && contentNode.image && <img src={contentNode.image.url} />}
          <div className="teaser-content-description" style={{ paddingTop: '5px' }}>
            <InlineEditor
              initial={contentNode.description}
              field="description"
              placeholder={getPlaceHolderLabel(nodeTypeConfig, 'description')}
              skey={contentNode.key}
              href={contentNode.href}
            />

            {contentNode.linkedContent && (
              <div>
                <strong>[ {contentNode.linkedContent.callToAction}]</strong>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TeaserRow;
